// import { DatePicker } from "antd";
import Label from "../Label";
import { twMerge } from "tailwind-merge";
// import dayjs from "dayjs";
// import customParseFormat from "dayjs/plugin/customParseFormat";
import YearPicker from "./YearPicker";

// dayjs.extend(customParseFormat);

export default function DateInput({
  label,
  labelClass,
  style,
  value,
  disabled,
  required = false,
  className,
  onBlur,
  note,
  noteClass,
  dateFormat = "DD-MM-YYYY",
  onChange,
  maxDate,
  ...props
}) {
  const handleChange = (date) => {
    if (!date) return;
    onChange(date);
  };

  return (
    <div
      className={`flex flex-col relative ${className ?? ""}`}
      style={{...style, direction: props.dir || 'ltr'}}
    >
      {label && (
        <Label
          label={label}
          className={twMerge(
            "text-[#818181] text-sm font-light mb-0",
            labelClass
          )}
          showTooltip={false}
          required={required}
        />
      )}
      {/* <DatePicker
        value={value}
        onChange={handleChange}
        id={props.id ?? ""}
        placeholder={props.placeholder ?? `Write ${label} Here`}
        className={`input-field ${props.inputClass ?? ""} ${
          props.inputDivClass ?? ""
        } ${disabled ? "disabled" : ""}`}
        format={dateFormat}
        inputReadOnly={true}
        maxDate={dayjs(maxDate, dateFormat)}
        allowClear={false}
        {...props}
        getPopupContainer={(trigger) => trigger.parentNode}
      /> */}
      <YearPicker
        value={value}
        onChange={handleChange}
        className={`input-field ${props.inputClass ?? ""} ${disabled ? "disabled" : ""}`}
        placeholder={props.placeholder ?? `Write ${label} Here`}
        required={required}
        minYear={1951}
        {...props}
      />

      {note && (
        <p className={twMerge("text-xs text-gray-600 italic", noteClass)}>
          {note}
        </p>
      )}
    </div>
  );
}
